import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setIsVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-130" data-mp="3pfv7bi19qetc">
      {isVisible ? <motion.div initial={{
      y: 90
    }} animate={{
      y: 0
    }} exit={{
      y: 90
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 32
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-ink/10 bg-cream/95 px-4 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] pt-3 backdrop-blur md:hidden" data-id="element-131" data-mp="3ucvha418o1pq">
          <div className="flex items-center gap-3" data-id="element-132" data-mp="c55wfwe8a3w0">
            <div className="leading-tight" data-id="element-133" data-mp="gyqwdtzdt7xu">
              <p className="font-sans text-[10px] uppercase tracking-[0.16em] text-ink/50" data-id="element-134" data-mp="gzk00m31nhbr">
                Hoy
              </p>
              <p className="font-display text-xl font-semibold text-ink" data-id="element-135" data-mp="27az9ytav7vc">
                $19.990
              </p>
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex-1 rounded-full bg-clay px-4 py-3.5 text-center font-sans text-[13px] font-semibold uppercase tracking-[0.06em] text-cream shadow-soft active:scale-[0.99]" data-id="element-136" data-mp="gx9wnzd16f9r">
              🧼 Quiero mi guía
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}